export type KeyFact = {
  title?: string;
  value?: string;
  subContent?: string;
  subtitle?: string;
  tooltip?: string;
  asOfDate?: string;
  rank?: string;
  valueFormat?: string;
  variant?: string;
  disclaimerCode?: string;
};

export enum ValueFormat {
  date = 'date',
  percentage = 'percentage',
  USD = 'USD',
  stars = 'stars',
  morningstarMedalistRating = 'morningstar-medalist-rating',
}
export type KeyFactArray = KeyFact[];

export type KeyFactWithRank = KeyFact & { rank: string };
